<template>
  <div v-if="versionsStore.hasVersionsToRestore" data-testid="viewer-versions-list">
    <h3 class="mb-1 font-semibold">Previous versions</h3>
    <ul class="flex flex-col gap-2.5">
      <li
        v-for="version in versionsStore.restoreList"
        :key="version.id"
        class="p-2.5 flex gap-2.5 items-center border rounded-10 border-slate-300 dark:border-zinc-700"
      >
        <div class="flex items-center justify-center w-40 h-40 border rounded-md border-slate-200 bg-slate-100">
          <img :src="version.links.thumbnailUrl" class="object-contain w-full h-full" />
        </div>
        <div>
          <p class="px-3 text-sm">{{ formatDate(version.lastModifiedAt) }}</p>
          <p class="pt-2">
            <Button
              type="link"
              variant="black"
              icon="general.openInNewTab"
              icon-size="xs"
              data-testid="viewer-versions-button-preview"
              @click.prevent="openInNewTab(version?.links.thumbnailUrl)"
              >Preview</Button
            >
          </p>
          <p>
            <Button
              type="link"
              variant="black"
              icon="general.copyDocument"
              icon-size="xs"
              data-testid="viewer-versions-button-duplicate"
              @click.prevent="id && restore(id, version?.id, true)"
              >Duplicate</Button
            >
          </p>
          <p>
            <Button
              type="link"
              variant="black"
              icon="general.backup"
              icon-size="xs"
              data-testid="viewer-versions-button-restore"
              @click.prevent="id && restore(id, version?.id, false)"
              >Restore</Button
            >
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { Button } from '@/storybook/button';
import { useVersionsStore } from '@/store/useVersionsStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { useTrack, TrackEvents } from '@/composables/useTrack';

const versionsStore = useVersionsStore();
const viewerItemStore = useViewerItemStore();

const { id } = storeToRefs(viewerItemStore);
const { trackItemOwner } = useTrack();

const restore = (id: string, versionId: string, duplicate: boolean) => {
  trackItemOwner(duplicate ? TrackEvents.VERSIONS_MODAL_DUPLICATE_CLICK : TrackEvents.VERSIONS_MODAL_RESTORE_CLICK).then(() => {
    versionsStore.restore(id, versionId, duplicate);
  });
};

const openInNewTab = (url?: string) => {
  if (!url) {
    return;
  }
  window.open(url, '_blank');
};
const formatDate = (date?: string) => (date ? new Date(date).toLocaleString() : '');
</script>
